import axios from 'axios';
import { useNavigate } from 'react-router-dom';
export const baseURL='https://api.keralaplots.com/api'; 
//export const baseURL='http://localhost:3002/api'; 
export const mediaUrl = 'https://api.keralaplots.com/';
const axiosInstance = axios.create({    
    baseURL: baseURL,
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Session expired or invalid session
            useNavigate('/login');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
